var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_225_224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1209 13.125C15.4756 13.125 17.3496 11.2153 17.3496 8.85938C17.3496 6.50344 15.4407 4.59375 13.1209 4.59375C10.7662 4.59375 8.89219 6.50344 8.89219 8.85938C8.85527 11.2137 10.7666 13.125 13.1209 13.125ZM15.1717 14.4375H11.0783C7.85859 14.4375 5.25 16.8861 5.25 19.9049C5.25 20.5119 5.7709 21 6.41484 21H19.8352C20.4791 21 21 20.5119 21 19.9049C21 16.8861 18.3914 14.4375 15.1717 14.4375ZM21 6.5625C22.8121 6.5625 24.2812 5.09332 24.2812 3.28125C24.2812 1.46918 22.8129 0 21 0C19.1879 0 17.7188 1.46918 17.7188 3.28125C17.7188 5.09332 19.1871 6.5625 21 6.5625ZM7.54277 8.85938C7.54277 8.63588 7.58305 8.42338 7.60877 8.20682C7.16133 7.96113 6.66914 7.875 6.14824 7.875H3.61266C1.61766 7.875 0 9.58945 0 11.7018C0 12.1242 0.32349 12.4688 0.722695 12.4688H8.90531C8.06777 11.4926 7.54277 10.2416 7.54277 8.85938ZM5.25 6.5625C7.06207 6.5625 8.53125 5.09332 8.53125 3.28125C8.53125 1.46918 7.06289 0 5.25 0C3.43793 0 1.96875 1.46918 1.96875 3.28125C1.96875 5.09332 3.43793 6.5625 5.25 6.5625ZM22.6365 7.875H20.1001C19.5751 7.875 19.0796 7.99956 18.6293 8.21297C18.6539 8.42871 18.6949 8.63789 18.6949 8.85938C18.6949 10.242 18.1707 11.493 17.3348 12.4688H25.5257C25.926 12.4688 26.25 12.1242 26.25 11.7018C26.25 9.58945 24.634 7.875 22.6365 7.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_225_224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.25,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.6493865cc3d3492e33be70138901d172.svg";
export { ForwardRef as ReactComponent };